// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Yu","srOnly":"Zu"};